( function( app ) {
  const COMPONENT = {
    init: function() {
      function updateCardHeroTheme() {
        const bg = document.querySelector( '.card-hero' );
        if ( !bg ) return;

        if ( window.innerWidth >= 1024 ) {
          bg.classList.add( 'theme-three' );
          bg.classList.remove( 'theme-four' );
        } else {
          bg.classList.add( 'theme-four' );
          bg.classList.remove( 'theme-three' );
        }
      }

      updateCardHeroTheme();
      window.addEventListener( 'resize', updateCardHeroTheme );
      window.addEventListener( 'orientationchange', updateCardHeroTheme );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'card-hero', COMPONENT );
} )( app );
